<mat-card class="no-media">
    <div class="form form-top">
        <h5>Filtros</h5>
        <div class="filtros">
            <mat-form-field appearance="fill">
                <mat-label>Month and Year</mat-label>
                <input
                    matInput
                    [max]="maxDate"
                    [matDatepicker]="dp"
                    [formControl]="date"
                />
                <mat-hint>MM/YYYY</mat-hint>
                <mat-datepicker-toggle
                    matSuffix
                    [for]="dp"
                ></mat-datepicker-toggle>
                <mat-datepicker
                    #dp
                    startView="multi-year"
                    (monthSelected)="setMonthAndYear($event, dp)"
                    panelClass="example-month-picker"
                >
                </mat-datepicker>
            </mat-form-field>
            <mat-form-field color="accent" class="title">
                <input
                    matInput
                    class="form-control"
                    placeholder="Titulo del Reporte"
                    [(ngModel)]="dateString"
                />
            </mat-form-field>
        </div>
        <button class="print_button" mat-raised-button (click)="print()">
            <mat-icon>print</mat-icon>Imprimir
        </button>
    </div>
</mat-card>
<h5 class="media-only">{{ dateString }}</h5>
<div class="tables-container">
    <div *ngFor="let data of dataSources" class="day mat-elevation-z8 page">
        <h5>{{ data.date | date: 'dd/MM/yyyy' }}</h5>
        <div class="row">
            <div class="col-md-6 container table2">
                <h6>Ingresos</h6>
                <table mat-table [dataSource]="data.income">
                    <ng-container matColumnDef="title">
                        <th mat-header-cell *matHeaderCellDef>Nombre</th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                            [ngClass]="element.style"
                        >
                            {{ element.title }}
                        </td>
                    </ng-container>

                    <!-- Name Column -->
                    <ng-container matColumnDef="count">
                        <th class="quantity" mat-header-cell *matHeaderCellDef>
                            Cantidad
                        </th>
                        <td
                            class="quantity"
                            mat-cell
                            *matCellDef="let element"
                            [ngClass]="element.style"
                        >
                            {{ element.count }}
                        </td>
                    </ng-container>

                    <!-- Weight Column -->
                    <ng-container matColumnDef="total">
                        <th class="quantity" mat-header-cell *matHeaderCellDef>
                            Total
                        </th>
                        <td
                            class="quantity"
                            mat-cell
                            *matCellDef="let element"
                            [ngClass]="element.style"
                        >
                            {{ element.total | currency }}
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr
                        mat-row
                        *matRowDef="let row; columns: displayedColumns"
                    ></tr>
                </table>
                <div
                    class="no-results"
                    [style.display]="
                        data.income.data.length === 0 ? '' : 'none'
                    "
                >
                    No hay ingresos registrados
                </div>
            </div>
            <div class="col-md-6 container table2">
                <h6>Egresos</h6>

                <table mat-table [dataSource]="data.outcome">
                    <ng-container matColumnDef="title">
                        <th mat-header-cell *matHeaderCellDef>Nombre</th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                            [ngClass]="element.style"
                        >
                            {{ element.title }}
                        </td>
                    </ng-container>

                    <!-- Name Column -->
                    <ng-container matColumnDef="count">
                        <th class="quantity" mat-header-cell *matHeaderCellDef>
                            Cantidad
                        </th>
                        <td
                            class="quantity"
                            mat-cell
                            *matCellDef="let element"
                            [ngClass]="element.style"
                        >
                            {{ element.count }}
                        </td>
                    </ng-container>

                    <!-- Weight Column -->
                    <ng-container matColumnDef="total">
                        <th class="quantity" mat-header-cell *matHeaderCellDef>
                            Total
                        </th>
                        <td
                            class="quantity"
                            mat-cell
                            *matCellDef="let element"
                            [ngClass]="element.style"
                        >
                            {{ element.total | currency }}
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr
                        mat-row
                        *matRowDef="let row; columns: displayedColumns"
                    ></tr>
                </table>
                <div
                    class="no-results"
                    [style.display]="
                        data.outcome.data.length === 0 ? '' : 'none'
                    "
                >
                    No hay egresos registrados
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-4">
                <mat-card class="total">
                    <p>
                        Total ingresos:
                        <label>{{ data.total_income | currency }}</label>
                    </p>
                </mat-card>
            </div>
            <div class="col-md-4">
                <mat-card class="total">
                    <p>
                        Total egresos:
                        <label>{{ data.total_outcome | currency }}</label>
                    </p>
                </mat-card>
            </div>
            <div class="col-md-4">
                <mat-card class="total">
                    <p>
                        Saldo: <label>{{ data.balance | currency }}</label>
                    </p>
                </mat-card>
            </div>
        </div>
    </div>
</div>
